export default __webpack_public_path__ + "static/testimonial_2-3b6efe84453b0f753514e6301d178f95.png";